import { jwtDecode, JwtPayload } from "jwt-decode"
import { useMemo, useState } from "react"
import { useQuery } from "react-query"
import { AnalyticTable } from "../api/analyticTable"
import { isEmpty } from "lodash"
import { hydraTransform } from "../shared/utils/hydraTransformer"
import { TAnalyticView } from "../shared/types/analyticView.type"

export type DecodedToken = JwtPayload & {
    iu?: string,
    iu_iri?: string,
    roles: string[]
    username?: string
}

type UseAsAdminProps = {
    queryEnabled: boolean
}

export const VIEW_PREFIX = 'CSM_'

export const useAsAdmin = ({ queryEnabled }: UseAsAdminProps) => {
    //State
    const [analyticViews, setAnalyticViews] = useState<Partial<TAnalyticView>[]>([])

    const token = localStorage.getItem('token')

    const decodedToken = useMemo(() => {
        if (token) {
            return jwtDecode(token) as DecodedToken
        }
    }, [token])

    const analyticViewQuery = useQuery(['admin_analytics_view'], () => AnalyticTable.getConfigs(decodedToken?.iu_iri), {
        enabled: queryEnabled && Boolean(decodedToken?.iu_iri),
        onSuccess: (response) => {

            let data = hydraTransform(response.data)

            if (isEmpty(data)) return

            setAnalyticViews(data.map(view => ({ ...view, name: VIEW_PREFIX.concat(view?.name ?? "") })))

        }
    })


    return {
        analyticViews,
        isAnalyticsViewsLoading: analyticViewQuery.isLoading,
        isConnectedAs: decodedToken?.iu_iri
    }
}